(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (window.StarryYouphemismCarousel) {
      window.StarryYouphemismCarousel();
      return;
    }

    const timers = new WeakMap();
    const transitionDuration = 700;

    const waitForImage = async (image) => {
      if (!image) return false;

      if (!image.complete) {
        const loaded = await new Promise((resolve) => {
          const cleanup = () => {
            image.removeEventListener('load', onLoad);
            image.removeEventListener('error', onError);
          };
          const onLoad = () => {
            cleanup();
            resolve(true);
          };
          const onError = () => {
            cleanup();
            resolve(false);
          };

          image.addEventListener('load', onLoad, { once: true });
          image.addEventListener('error', onError, { once: true });
        });

        if (!loaded) return false;
      }

      if (!image.naturalWidth) return false;

      if (typeof image.decode === 'function') {
        try {
          await image.decode();
        } catch (error) {
          // Some browsers reject decode after cache hits; complete/naturalWidth still confirms the image is usable.
        }
      }

      return image.naturalWidth > 0;
    };

    window.StarryYouphemismCarousel = () => {
      document.querySelectorAll('.hero-youphemism-carousel').forEach((carousel) => {
        window.clearTimeout(timers.get(carousel));

        const images = Array.from(carousel.querySelectorAll('.hero-youphemism-carousel__image'));
        if (!images.length) return;

        const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        const interval = Number(carousel.dataset.interval) || 6000;
        let currentIndex = Math.max(
          0,
          images.findIndex((image) => image.classList.contains('is-active'))
        );

        images.forEach((image, index) => {
          image.loading = 'eager';
          image.classList.toggle('is-active', index === currentIndex);
          image.classList.remove('is-entering');
        });

        if (reduceMotion || images.length < 2) return;

        const scheduleNext = () => {
          const timer = window.setTimeout(() => showNext(), interval);
          timers.set(carousel, timer);
        };

        const showNext = async () => {
          if (!carousel.isConnected) return;

          let nextIndex = currentIndex;
          let nextImage;
          let attempts = 0;

          while (attempts < images.length) {
            nextIndex = (nextIndex + 1) % images.length;
            nextImage = images[nextIndex];

            if (nextIndex !== currentIndex && (await waitForImage(nextImage))) break;

            attempts += 1;
          }

          if (attempts >= images.length || nextIndex === currentIndex || !nextImage) {
            scheduleNext();
            return;
          }

          nextImage.classList.add('is-entering');

          window.setTimeout(() => {
            if (!carousel.isConnected) return;

            images[currentIndex].classList.remove('is-active');
            nextImage.classList.add('is-active');
            nextImage.classList.remove('is-entering');
            currentIndex = nextIndex;
            scheduleNext();
          }, transitionDuration);
        };

        scheduleNext();
      });
    };

    window.StarryYouphemismCarousel();
    document.addEventListener('shopify:section:load', window.StarryYouphemismCarousel);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
